import { type ErrorHandler, inject, Injectable } from '@angular/core';
import { isExpectedUnauthorized } from '@frontendlib/common/features/sentry/sentry-events';
import * as Sentry from '@sentry/angular';
import { ChunkLoadRecoveryService } from './chunk-load-recovery.service';

/**
 * The app's ErrorHandler: Sentry's, minus what is not a bug. An expired session's 401 is answered by signing the
 * person out, and a chunk-load failure after a deploy is recovered by a reload (which reports the repeat itself).
 * Both are recognised here, before Sentry's handler turns the error into a message and its type is lost.
 */
@Injectable()
export class AppErrorHandler implements ErrorHandler {
  private readonly sentry = Sentry.createErrorHandler();
  private readonly chunkLoads = inject(ChunkLoadRecoveryService);

  public handleError(error: unknown): void {
    if (isExpectedUnauthorized(error)) return;
    if (this.chunkLoads.recover(error) !== 'not-chunk-load') return;
    this.sentry.handleError(error);
  }
}
